export enum VARIANTS {
  SHORT = 'SHORT',
  LONG = 'LONG',
  ALL = 'ALL',
}
